import { defineMessages } from 'react-intl'

export default defineMessages({
  navHome: {
    id: 'CustomerApp.nav.home',
    defaultMessage: 'Home',
  },
  navOrders: {
    id: 'CustomerApp.nav.orders',
    defaultMessage: 'Orders',
  },
  navTeam: {
    id: 'CustomerApp.nav.team',
    defaultMessage: 'Team',
  },
  navRoster: {
    id: 'CustomerApp.nav.roster',
    defaultMessage: 'Roster',
  },
  navReports: {
    id: 'CustomerApp.nav.reports',
    defaultMessage: 'Reports',
  },
  navTraining: {
    id: 'CustomerApp.nav.training',
    defaultMessage: 'Training',
  },
  navNewOrder: {
    id: 'CustomerApp.nav.newOrder',
    defaultMessage: 'New order',
  },
  navSearchVoices: {
    id: 'CustomerApp.nav.searchVoices',
    defaultMessage: 'Search voices',
  },
  navSearchVoicesHref: {
    id: 'CustomerApp.nav.searchVoices.href',
    defaultMessage: 'https://www.voicearchive.com/en/voicefinder?utm_source=voice-portal-dashboard',
  },
  navBilling: {
    id: 'CustomerApp.nav.billing',
    defaultMessage: 'Billing',
  },
  navVoiceSelectors: {
    id: 'CustomerApp.nav.voiceSelectors',
    defaultMessage: 'Voice Selectors',
  },
  navDashboard: {
    id: 'SupplierApp.nav.dashboard',
    defaultMessage: 'Dashboard',
  },
  navNewJobs: {
    id: 'SupplierApp.nav.newJobs',
    defaultMessage: 'New Jobs',
  },
  navOpenJobs: {
    id: 'SupplierApp.nav.openJobs',
    defaultMessage: 'Open Jobs',
  },
  navCompletedJobs: {
    id: 'SupplierApp.nav.completedJobs',
    defaultMessage: 'Completed Jobs',
  },
  navBookings: {
    id: 'SupplierApp.nav.bookings',
    defaultMessage: 'Bookings',
  },
  navInfo: {
    id: 'SupplierApp.nav.info',
    defaultMessage: 'Info',
  },
  navProfile: {
    id: 'SupplierApp.nav.profile',
    defaultMessage: 'Profile',
  },
  navOverview: {
    id: 'SupplierApp.nav.overview',
    defaultMessage: 'Overview',
  },
  navManageVoiceTalents: {
    id: 'SupplierApp.nav.manageVoiceTalents',
    defaultMessage: 'Manage Voice Talents',
  },
  navContact: {
    id: 'SupplierApp.nav.contact',
    defaultMessage: 'Contact us',
  },
  navContactHref: {
    id: 'SupplierApp.nav.contact.href',
    defaultMessage: 'mailto:studio@voicearchive.com',
  },
  navMyAiVoice: {
    id: 'SupplierApp.nav.aiVoiceClone',
    defaultMessage: 'AI Voice Clone',
  },
})
